export const userDataForm = ['password', 'confirm_password']
export const disabledUserFields = ['email', 'companyName']


export const completeProfileForm = ['first_name', 'last_name']
